<template>
  <div class="search-wrap">
    <div class="search-bar plr12 mb16">
      <i class="jfi-back-v2"></i>
      <input
        @click.prevent="triggerSearchModal($event)"
        class="search-query-input"
        id="searchQueryInput"
        type="text"
        name="searchQueryInput"
        placeholder="Search Pizzas, Sides &amp; more..."
      />
      <button
      @click.prevent="triggerSearchModal($event)"
        class="search-query-submit"
        id="searchCta"
        type="submit"
        name="searchCta"
      >
        <i class="jfi-search"></i>
      </button>
    </div>

    <!-- search modal -->
    <search-modal
      v-if="showSearchModal"
      :showSearchModal="showSearchModal"
      :moduleProps="moduleProps"
      @close="closeSearchModal()"
    ></search-modal>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import UserActivityTracking from "../helpers/UserActivityTracking";
import {
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY,
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT
} from "../config/vwoKeys";
import { projectBasePathWithFolder } from "../config/apiEndpoints";
import localStorageFunc from '../helpers/localStorageFunc';
import PageNames from "../config/pageNames";

export default {
  name: "SearchProducts",
  props: ["moduleProps"],
  components: {
    SearchModal: defineAsyncComponent(() => import("./SearchModal.vue"))
  },
  data() {
    return {
      showSearchModal: false,
    };
  },
  methods: {
    triggerSearchModal(e) {
      let exp = this.$store.state.Config.vwoExperiments;
      // for Variant_U - redirecting to separate menu with searchModal already open
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_W ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_X ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_Y ||
        Utility.getLinkRewriteFromSiteprops() === PageNames.NEXTGEN_LINKREWRITE_HOME
      ) {
        let linkRewrite = Utility.getLinkRewriteFromSiteprops();
        if (
          linkRewrite === VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_U ||
          linkRewrite === VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY.VARIANT_W ||
          linkRewrite === PageNames.NEXTGEN_LINKREWRITE_HOME
        ) {
          let url =
            projectBasePathWithFolder +
            '/menu/' +
            localStorageFunc.storeId() +
            Utility.getUrlQueryString();
          url = this.addShowSearchModalParam(url);
          window.location.href = url;
        }
      }
      else {
        document.body.classList.add("body-stop-scroll-mobile");
        this.showSearchModal = true;
        //Amplitude Click event load
        const eventObj = Utility.amplitudeEventObj("click", "search", "3", {});
        setEvents("amplitude", "Click", eventObj);
        UserActivityTracking.searchClicked(0);
      }
    },
    closeSearchModal() {
      this.showSearchModal = false;
    },
    addShowSearchModalParam(url) {
      url = Utility.addUpdateParam(url, "showSearchModal", true);
      url = Utility.addUpdateParam(url, "scrollTo", "menuTop");
      return url;
    }
  },
};
</script>
